import { ActivityService } from './../../Services/activity.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-tracker-list',
  template: require('./activity-tracker-list.component.html'),
  styles: [require('./activity-tracker-list.component.css')]
})
export class ActivityTrackerListComponent implements OnInit {
  loading: boolean = false;
  activities: any[] = [];
  currentYear = new Date().getFullYear();
  allAvailableYears: number[]=[];
  constructor(private activityService: ActivityService) {
  }

  ngOnInit() {
    this.getAllActivities();
     this.activityService.getYears().subscribe( x => {
      this.allAvailableYears = x.reverse();
      // this.currentYear =  this.allAvailableYears[this.allAvailableYears.length - 1];
      this.currentYear =  this.allAvailableYears[0];
      this.getAllActivities()
    })
  }

  ngAfterViewInit() {
    this.getAllActivities();
   
  }

  getAllActivities(){
    this.loading = true;
    this.activityService.getActivities(this.currentYear).subscribe(x => {
      if (x.status == 200) {
        this.activities = x.value;
      }
      this.loading = false;
    })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/activity-tracker-list/activity-tracker-list.component.ts